export enum TeamEnum {
  DEV = 'dev',
  DESIGN = 'design',
  DIRECTION = 'direction',
  PO = 'po',
  QWERI = 'qweri',
}

export const getTeamEnumValues = (): string[] => Object.values(TeamEnum);
